/**
 * @desc tableau账号获取票证
 */
const URL = "/rantion-ucenter";
import http, { updateResponse } from "@/http";
export function request(tableauNo: string | number, options?: any) {
  return updateResponse(
    http(URL + `/sysUserTableau/tableauTrustByTableauNo/${tableauNo}`, {
      method: "GET",

      ...options,
    }),
  );
}
